var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1833 48H9.81959C8.01959 48 6.54688 46.5273 6.54688 44.7273V3.27272C6.54687 1.47272 8.01959 0 9.81959 0H29.456L41.456 12V44.7273C41.456 46.5273 39.9833 48 38.1833 48Z",
    fill: "#54FF99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.457 0L41.457 12H29.457V0Z",
    fill: "#3DB56D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1836 18.5459H33.82V21.2732H14.1836V18.5459ZM14.1836 25.0913H33.82V27.8186H14.1836V25.0913ZM14.1836 31.6369H28.3654V34.3641H14.1836V31.6369Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5719bbb907b6af90368c3a06cdd9974d.svg";
export { ForwardRef as ReactComponent };